import React from 'react';
import PropTypes from 'prop-types';
import { zoneIsDisabled } from 'util/zoneDrawing';

// components
import ZoneCollectionLayer from './ZoneCollectionLayer';

// utils
import { styleMethods } from 'dataviz/config/map';

/** A map layer for displaying an editable (Script Creator view) prescription, including its zone shapes. This is
    intended to be used in conjunction with a comparison layer underneath. */
const EditingLayer = ({
  selectedZoneIds,
  drawingState,
  map,
  onClickZone,
  zones
}) => (
  <section className='vra-population-editing-layer'>
    <ZoneCollectionLayer
      layerName='editing'
      map={map}
      onClickZone={ (zoneId) => { if (onClickZone) {onClickZone(zoneId);} } }
      styleFunction={styleMethods.editingZones.bind(null, { drawingState, selectedZoneIds })}
      zoneIsDisabled={zoneIsDisabled.bind(null, drawingState)}
      zoneIsSelected={zoneIsDisabled.bind(null, selectedZoneIds)}
      zones={zones}
    />
  </section>
);

EditingLayer.propTypes = {
  drawingState: PropTypes.string.isRequired,
  map: PropTypes.object, // Inserted by mapping/leaflet.
  onClickZone: PropTypes.func,
  selectedZoneIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  zones: PropTypes.object.isRequired
};

export default EditingLayer;
